import { createQueryKeys } from '../../factories';

export const BACKGROUND_JOB_NAMESPACE = ['background_jobs'];
export const backgroundJobQueryKeyFactory = createQueryKeys(
	BACKGROUND_JOB_NAMESPACE
);
